<script setup lang="ts">
import { ArrowRight } from 'lucide-vue-next'

import AudienceTemplate from '@/views/audience/components/AudienceTemplate.vue'

import useAudienceTemplates from '@/views/audience/composables/templates'

const router = useRouter()
const { t } = useI18n()

const { recommendedTemplates } = useAudienceTemplates()

const filteredTemplates = computed(() => {
  return recommendedTemplates.value.slice(0, 3)
})

const goToTemplates = () => {
  router.push({
    name: 'AudienceTemplates'
  })
}
</script>

<template>
  <div>
    <div class="flex flex-col gap-4 mb-4 md:flex-row md:items-center md:justify-between">
      <div class="flex flex-col gap-2">
        <p class="text-foreground font-medium">{{ t('pages.audience.templates.title') }}</p>
        <p class="text-sm font-normal text-muted-foreground">
          {{ t('pages.audience.templates.description') }}
        </p>
      </div>

      <Button variant="ghost-primary" class="self-start md:self-auto" @click="goToTemplates">
        {{ t('pages.audience.templates.discoverAll') }}
        <ArrowRight />
      </Button>
    </div>
    <div class="grid md:grid-cols-3 gap-4">
      <AudienceTemplate v-for="template in filteredTemplates" :key="template.id" :template="template" />
    </div>
  </div>
</template>
